import { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  where,
  Timestamp,
} from "firebase/firestore";

function TodayScreen() {
  const [data, setData] = useState({
    users: 0,
    deposit: 0,
    withdraw: 0,
    profit: 0,
  });

  useEffect(() => {
    loadToday();
  }, []);

  const loadToday = async () => {
    try {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const todayTs = Timestamp.fromDate(today);

      // USERS
      const usersSnap = await getDocs(
        query(collection(db, "users"), where("createdAt", ">", todayTs))
      );

      // DEPOSIT
      const depositSnap = await getDocs(collection(db, "deposit_requests"));
      let todayDeposit = 0;

      depositSnap.forEach((doc) => {
        const d = doc.data();
        if (
          d.status === "approved" &&
          d.createdAt?.seconds > todayTs.seconds
        ) {
          todayDeposit += d.amount || 0;
        }
      });

      // WITHDRAW
      const withdrawSnap = await getDocs(collection(db, "withdraw_requests"));
      let todayWithdraw = 0;

      withdrawSnap.forEach((doc) => {
        const d = doc.data();
        if (
          d.status === "approved" &&
          d.createdAt?.seconds > todayTs.seconds
        ) {
          todayWithdraw += d.amount || 0;
        }
      });

      // PROFIT
      const collections = [
        "cs_tournaments",
        "lw_tournaments",
        "br_tournaments",
        "br_s_tournaments",
        "onetap_tournaments",
      ];

      let todayProfit = 0;

      for (let col of collections) {
        const snap = await getDocs(collection(db, col));

        snap.forEach((doc) => {
          const d = doc.data();

          if (
            d.status === "completed" &&
            d.time?.seconds > todayTs.seconds
          ) {
            const entry = d.entryFee || 0;
            const spots = d.totalSpots || 0;
            const prize = d.prizePool || 0;

            todayProfit += (entry * spots) - prize;
          }
        });
      }

      setData({
        users: usersSnap.size,
        deposit: todayDeposit,
        withdraw: todayWithdraw,
        profit: todayProfit,
      });

    } catch (e) {
      console.error("TodayScreen Error:", e);
    }
  };

  return (
    <div style={container}>
      <h1 style={title}>📅 Today Stats</h1>

      <div style={grid}>
        <Card title="🆕 Users" value={data.users} />
        <Card title="💳 Deposit" value={`₹${data.deposit}`} />
        <Card title="💸 Withdraw" value={`₹${data.withdraw}`} />

        <Card
          title="📊 Net"
          value={`₹${data.deposit - data.withdraw}`}
        />

        <Card title="💰 Match Profit" value={`₹${data.profit}`} />
      </div>
    </div>
  );
}

// 🔥 CARD
function Card({ title, value }) {
  const [hover, setHover] = useState(false);

  return (
    <div
      style={{
        ...card,
        transform: hover ? "translateY(-5px)" : "none",
        background: hover ? "#222842" : "#1A1F2E",
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <h3 style={cardTitle}>{title}</h3>
      <h2 style={cardValue}>{value}</h2>
    </div>
  );
}

/* 🔥 STYLES */

const container = {
  color: "white",
  padding: 20,
  background: "linear-gradient(135deg, #0F1221, #0A0D1A)",
  minHeight: "100vh",
};

const title = {
  marginBottom: 20,
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: 20,
};

const card = {
  background: "#1A1F2E",
  padding: 20,
  borderRadius: 14,
  textAlign: "center",
  border: "1px solid rgba(255,255,255,0.05)", // no white border
  transition: "all 0.25s ease",
  cursor: "pointer",
};

const cardTitle = {
  fontSize: 14,
  opacity: 0.7,
  marginBottom: 10,
};

const cardValue = {
  fontSize: 24,
  fontWeight: "bold",
};

export default TodayScreen;